<template>
  <div :style="maxHeight" style="overflow-y: auto;overflow-x: hidden">
    <div style="margin-left: 40px">
      <el-button v-if="this.parentData" type="success" :loading="loading" @click="deleteChartData">{{ "数据修复" }}
      </el-button>
      <el-button type="primary">{{ "物件选择" }}</el-button>
      <el-select v-model="wuJianId" clearable @change="renderAllEcharts" placeholder="物件名称"
                 style="width: 200px;">
        <el-option
            v-for="item in wuJianNames"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-select v-model="field" @change="renderAllEcharts" style="width: 80px; margin-left: 10px">
        <el-option
            v-for="item in fieldNames"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-select v-model="supplier" @change="renderAllEcharts" clearable placeholder="供应商"
                 style="width: 200px;">
        <el-option
            v-for="item in suppliers"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
    </div>
    <el-row style="height: 45%;margin-top: 5px">
      <el-col :span="12" style="border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;height: 100%">
        <div class="title">{{ '物件别型材不良推移' }}
        </div>
        <div v-loading="wuJianChartLoading" element-loading-text="数据加载中" style="width: 100%;height: 90%"
             id="wuJianXC"/>
      </el-col>
      <el-col :span="12" style="border-bottom: 8px solid whitesmoke;height: 100%">
        <div class="title">
          <span>{{ '不良项目占比' }}</span>
          <div class="space-between">
            <el-select v-model="pieDate.badType" @change="getPieChart" size="small"
                       style="width: 90px;margin-right: 10px">
              <el-option
                  v-for="item in badTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-date-picker v-model="pieDate.year" @change="getPieChart" format="YYYY 年" value-format="YYYY"
                            clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px"
                            size="small"/>
            <el-date-picker v-model="pieDate.month" @change="getPieChart" format="MM 月" value-format="MM" clearable
                            type="month" placeholder="月" style="width: 70px; margin-right: 10px" size="small"/>
            <!--              <el-date-picker v-model="pieDate.day" @change="getPieChart" format="DD 日" value-format="DD" clearable type="day" placeholder="日" style="width: 70px;" size="small"/>-->
          </div>
        </div>
        <div v-loading="pieChartLoading" element-loading-text="数据加载中" style="width: 100%;height: 90%"
             id="pieXC"/>
      </el-col>
    </el-row>
    <el-row style="height: 45%">
      <el-col :span="12" style="border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;height: 100%">
        <div class="title">
          <span>{{ '日不良率' }}</span>
          <el-date-picker v-model="dayBad.dateDay" @change="getDayChart" format="YYYY 年 M 月" value-format="YYYY-M-1"
                          type="month" placeholder="选择月份" style="width: 130px" size="small"/>
        </div>
        <div v-loading="dayBadLoading" element-loading-text="数据加载中" style="width: 100%;height: 90%"
             id="dayBadXC"/>
      </el-col>
      <el-col :span="12" style="border-bottom: 8px solid whitesmoke;height: 100%">
        <div class="title">{{ '受入型材不良堆积图' }}<div class="space-between">
          <el-date-picker v-model="drumDate.year" @change="getDrumChart" format="YYYY 年" value-format="YYYY"
                          clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px"
                          size="small"/>
          <el-date-picker v-model="drumDate.month" @change="getDrumChart" format="MM 月" value-format="MM" clearable
                          type="month" placeholder="月" style="width: 70px; margin-right: 10px" size="small"/>
          <!--              <el-date-picker v-model="drumDate.day" @change="getPieChart" format="DD 日" value-format="DD" clearable type="day" placeholder="日" style="width: 70px;" size="small"/>-->
        </div>
        </div>
        <div v-loading="drumChartLoading" element-loading-text="数据加载中" style="width: 100%;height: 90%"
             id="drumXC"/>
      </el-col>
    </el-row>
    <el-row style="height: 45%">
      <el-col :span="12" style="border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;height: 100%">
        <div class="title">
          {{ '种类别型材不良推移' }}
          <div class="space-between">
            <el-date-picker v-model="typeBad.year" @change="getBlendChart" format="YYYY 年" value-format="YYYY"
                            clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px"
                            size="small"/>
            <el-select v-model="typeBad.type" @change="getBlendChart" clearable placeholder="总不良率" size="small"
                       style="width: 90px">
              <el-option
                  v-for="item in types"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div v-loading="blendChartLoading" element-loading-text="数据加载中" style="width: 100%;height: 90%"
             id="blendXC"/>
      </el-col>
      <el-col :span="12" style="border-bottom: 8px solid whitesmoke;height: 100%">
        <div class="title">
          {{ '型材检查产量' }}
          <div class="space-between">
            <el-date-picker v-model="classDate.year" @change="getClassDrumChart" format="YYYY 年" value-format="YYYY"
                            clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px"
                            size="small"/>
            <el-date-picker v-model="classDate.month" @change="getClassDrumChart" format="MM 月" value-format="MM"
                            clearable type="month" placeholder="月" style="width: 70px; margin-right: 10px"
                            size="small"/>
          </div>
        </div>
        <div v-loading="classChartLoading" element-loading-text="数据加载中" style="width: 100%;height: 90%"
             id="classXC"/>
      </el-col>
    </el-row>


    <!--        <div class="size">
              <div class="title">
                {{'供应商别型材不良推移'}}
                <div class="space-between">
                  <el-date-picker v-model="supplierBad.year" @change="getSupplierChart" format="YYYY 年" value-format="YYYY" clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px" size="small"/>
    &lt;!&ndash;              <el-select v-model="this.supplier" @change="getSupplierChart" clearable placeholder="供应商" size="small" style="width: 180px">
                    <el-option
                        v-for="item in suppliers"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>&ndash;&gt;
                </div>
              </div>
              <div v-loading="supplierChartLoading" element-loading-text="数据加载中" style="width: 470px;height: 260px" id="supplierXC"/>
            </div>-->


    <KfDialog v-model="dialogVisible" :item="dialogItem">

      <template #footer>
        <div style="display: flex;flex-direction: column;align-items: center;justify-content: space-around;">
          <div style="width:100%; display: flex;flex-direction: row;align-items: center;justify-content: space-around;">
            <span style="font-size: 24px;">{{this.chartData.name}}</span>
            <el-input-number v-model="this.chartData.value"/>
          </div>
          <el-button style="margin-top: 20px" type="primary" @click="editChartData">{{"保存"}}</el-button>
        </div>
      </template>
    </KfDialog>

    <KfDialog v-model="infoDialog" :item="dialogItem">

      <template #footer>
        <el-tabs v-model="activeName" class="demo-tabs">
          <el-tab-pane label="外观记录" name="first">
            <el-table v-loading="this.infoLoading" :data="this.dataInfo['bus_xingcai_waiguan_zhijian_record']" height="350" style="width: 100%;">
              <el-table-column prop="wujian_id" label="物件番号" width="120" />
              <el-table-column prop="supplier_name" label="供应商" width="280"/>
              <el-table-column prop="xingcai_no" label="型材番号" width="150" />
              <el-table-column prop="check_no" label="检查编号" width="280"/>
              <el-table-column prop="furnace_no"  label="炉号" width="150"/>
              <el-table-column prop="checked_count" label="检查数量" width="100" align="center"/>
              <el-table-column prop="create_time" label="检查时间" width="180" align="center"/>
              <el-table-column prop="huashang" label="划伤" width="80" align="center">
                <template #default="scope">
                  <div v-if="scope.row.huashang" style="color: red;">{{"有"}}</div>
                  <div v-else>{{"无"}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="fushi" label="腐蚀" width="80" align="center">
                <template #default="scope">
                  <div v-if="scope.row.fushi" style="color: red;">{{"有"}}</div>
                  <div v-else>{{"无"}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="aoxian" label="凹陷" width="80" align="center">
                <template #default="scope">
                  <div v-if="scope.row.aoxian" style="color: red;">{{"有"}}</div>
                  <div v-else>{{"无"}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="cashang" label="擦伤" width="80" align="center">
                <template #default="scope">
                  <div v-if="scope.row.cashang" style="color: red;">{{"有"}}</div>
                  <div v-else>{{"无"}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="jiaodu" label="角度不良" width="100" align="center">
                <template #default="scope">
                  <div v-if="scope.row.jiaodu" style="color: red;">{{"有"}}</div>
                  <div v-else>{{"无"}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="zhuangshang" label="撞伤" width="80" align="center">
                <template #default="scope">
                  <div v-if="scope.row.zhuangshang" style="color: red;">{{"有"}}</div>
                  <div v-else>{{"无"}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="anying" label="暗影" width="80" align="center">
                <template #default="scope">
                  <div v-if="scope.row.anying" style="color: red;">{{"有"}}</div>
                  <div v-else>{{"无"}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="pingmian" label="平面" width="80" align="center">
                <template #default="scope">
                  <div v-if="scope.row.pingmian" style="color: red;">{{"有"}}</div>
                  <div v-else>{{"无"}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="jiazha" label="夹渣" width="80" align="center">
                <template #default="scope">
                  <div v-if="scope.row.jiazha" style="color: red;">{{"有"}}</div>
                  <div v-else>{{"无"}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="bianxing" label="变形" width="80" align="center">
                <template #default="scope">
                  <div v-if="scope.row.bianxing" style="color: red;">{{"有"}}</div>
                  <div v-else>{{"无"}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="qipao" label="气泡" width="80" align="center">
                <template #default="scope">
                  <div v-if="scope.row.qipao" style="color: red;">{{"有"}}</div>
                  <div v-else>{{"无"}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="chiyin" label="齿印" width="80" align="center">
                <template #default="scope">
                  <div v-if="scope.row.chiyin" style="color: red;">{{"有"}}</div>
                  <div v-else>{{"无"}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="dingyan" label="钉眼" width="80" align="center">
                <template #default="scope">
                  <div v-if="scope.row.dinyan" style="color: red;">{{"有"}}</div>
                  <div v-else>{{"无"}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="yiwu" label="异物卷入" width="100" align="center">
                <template #default="scope">
                  <div v-if="scope.row.yiwu" style="color: red;">{{"有"}}</div>
                  <div v-else>{{"无"}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="yanse" label="颜色错误" width="100" align="center">
                <template #default="scope">
                  <div v-if="scope.row.yanse" style="color: red;">{{"有"}}</div>
                  <div v-else>{{"无"}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="guangshang" label="光伤" width="80" align="center">
                <template #default="scope">
                  <div v-if="scope.row.guangshang" style="color: red;">{{"有"}}</div>
                  <div v-else>{{"无"}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="mohen" label="模痕" width="80" align="center">
                <template #default="scope">
                  <div v-if="scope.row.mohen" style="color: red;">{{"有"}}</div>
                  <div v-else>{{"无"}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="duanzhuang" label="短装" width="80" align="center">
                <template #default="scope">
                  <div v-if="scope.row.duanzhuang" style="color: red;">{{"有"}}</div>
                  <div v-else>{{"无"}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="qita" label="其他" width="80" align="center">
                <template #default="scope">
                  <div v-if="scope.row.qita" style="color: red;">{{"有"}}</div>
                  <div v-else>{{"无"}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="wanqudu_result" label="弯曲度" width="80" align="center">
                <template #default="scope">
                  <div v-if="scope.row.wanqudu_result">{{"合格"}}</div>
                  <div v-else style="color: red;">{{"不合格"}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="niuningdu_result" label="扭拧度" width="80" align="center">
                <template #default="scope">
                  <div v-if="scope.row.niuningdu_result">{{"合格"}}</div>
                  <div v-else style="color: red;">{{"不合格"}}</div>
                </template>
              </el-table-column>
              <el-table-column fixed="right" prop="result"  label="结果" width="120">
                <template #default="scope">
                  <div v-if="scope.row.result === 'recheck_false'">{{"重检不合格"}}</div>
                  <div v-if="scope.row.result === 'recheck_true'">{{"重检合格"}}</div>
                  <div v-if="scope.row.result === 'false'">{{"不合格"}}</div>
                  <div v-if="scope.row.result === 'true'">{{"合格"}}</div>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="膜厚记录" name="second" v-if="this.dataInfo['bus_xingcai_mohou_zhijian_record']">
            <el-table v-loading="this.infoLoading" :data="this.dataInfo['bus_xingcai_mohou_zhijian_record']" height="350" style="width: 100%;">
              <el-table-column prop="wujian_id" label="物件番号" width="120" />
              <el-table-column prop="xingcai_no" label="型材番号" width="150" />
              <el-table-column prop="check_no" label="检查编号" width="200"/>
              <el-table-column prop="create_time" label="检查时间" min_width="250" align="center"/>
              <el-table-column fixed="right" prop="result"  label="结果" width="120">
                <template #default="scope">
                  <div v-if="scope.row.result === 'recheck_false'">{{"重检不合格"}}</div>
                  <div v-if="scope.row.result === 'recheck_true'">{{"重检合格"}}</div>
                  <div v-if="scope.row.result === 'false'">{{"不合格"}}</div>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="硬度记录" name="third" v-if="this.dataInfo['bus_xingcai_yingdu_zhijian_record']">
            <el-table v-loading="this.infoLoading" :data="this.dataInfo['bus_xingcai_yingdu_zhijian_record']" height="350" style="width: 100%;">
              <el-table-column prop="wujian_id" label="物件番号" width="120" />
              <el-table-column prop="xingcai_no" label="型材番号" width="150" />
              <el-table-column prop="check_no" label="检查编号" width="200"/>
              <el-table-column prop="create_time" label="检查时间" min_width="250" align="center"/>
              <el-table-column fixed="right" prop="result"  label="结果" width="120">
                <template #default="scope">
                  <div v-if="scope.row.result === 'recheck_false'">{{"重检不合格"}}</div>
                  <div v-if="scope.row.result === 'recheck_true'">{{"重检合格"}}</div>
                  <div v-if="scope.row.result === 'false'">{{"不合格"}}</div>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="尺寸记录" name="four" v-if="this.dataInfo['bus_chicun_zhijian_record']">
            <el-table v-loading="this.infoLoading" :data="this.dataInfo['bus_chicun_zhijian_record']" height="350" style="width: 100%;">
              <el-table-column prop="wujian_id" label="物件番号" width="120" />
              <el-table-column prop="xingcai_no" label="型材番号" width="150" />
              <el-table-column prop="check_no" label="检查编号" width="200"/>
              <el-table-column prop="create_time" label="检查时间" min_width="250" align="center"/>
              <el-table-column fixed="right" prop="result"  label="结果" width="120">
                <template #default="scope">
                  <div v-if="scope.row.result === 'recheck_false'">{{"重检不合格"}}</div>
                  <div v-if="scope.row.result === 'recheck_true'">{{"重检合格"}}</div>
                  <div v-if="scope.row.result === 'false'">{{"不合格"}}</div>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </template>
    </KfDialog>

  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  name: "ShouRuBoLiPage1",
  props: ['parentData'],

  data(){
    return{
      maxHeight:'',
      activeName:'first',
      infoLoading:false,
      dataInfo:{},
      infoDialog:false,
      dialogVisible:false,
      loading:false,
      dialogItem:{
        title:'',
        width:'30%'
      },
      chartData:{},
      dayBad:{
        dateDay:this.getDateFormat(),
      },
      badTypes:[
        {label:"一次不良",value:"ng1"},
        {label:"二次不良",value:"ng2"},
      ],
      pieDate:{
        year:this.$common.getCurrentYearByMonth().toString(),
        month:this.$common.getDateLabel(new Date().getUTCMonth() + 1),
        day:'',
        badType:'ng1'
      },
      typeBad:{
        type:'',
        year:this.$common.getCurrentYearByMonth().toString(),
      },
      types:[
        {
          value: 'F',
          label: 'F材',
        },
        {
          value: 'B',
          label: 'B材',
        }
      ],
      wuJianId:'',
      supplier:'',
      wuJianNames:[],
      yAxisName:'不良重量',
      field:'weight',
      fieldNames:[
        {value:'count',label:'数量'},
        {value:'weight',label:'重量'}
      ],
      suppliers:[],
      supplierBad:{
        supplier:'',
        year:this.$common.getCurrentYearByMonth().toString(),
      },
      /*不良项目占比*/
      optionPie:{
        type:'pie_chart',
        title: {
          text: '总数量',
          top: '37%',
          left: '49%',
          textAlign: 'center',
          textStyle: {
            color: 'black',
            fontSize: '20px',
            lineHeight: 30
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: "{b} : {c} ({d}%)"
        },
        legend: {
          type: 'scroll',
          orient: 'horizontal',
          top:0,
          data: [],
        },
        series: [
          {
            name: '不良项目',
            type: 'pie',
            radius: ['40%', '65%'],
            center: ['50%', '50%'],
            label:{
              show: true,
              formatter: '{b},{d}%'
            },
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      pieChartLoading:false,
      /*物件别不良推移*/
      wujianQuery:{},
      optionWuJian: {
        type:'wujian_chart',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          //data: ['Evaporation', 'Precipitation', 'Temperature']
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            min:0,
            max:100,
            interval:20,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(0)
              }
            }
          },
          {
            type: 'value',
            name: '不良率',
            min:0,
            max:10,
            interval:2,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(1) + '%'
              }
            }
          }
        ],
        series: [
          {
            name: '一次不良',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [
            ]
          },
          {
            name: '二次不良',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [
            ]
          },
          {
            name: '目标',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: []
          },
          {
            name: '实绩',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: []
          }
        ],
        dataZoom:[
          {
            start: 0,
            end: 100,
            type: 'slider',
            show: true,
            // xAxisIndex: [0],
            handleSize: 0,//滑动条的 左右2个滑动条的大小
            startValue: null, // 初始显示值
            endValue: null, // 结束显示值
            height: 15,//组件高度
            left: '5%', //左边的距离
            right: '4%',//右边的距离
            borderRadius: 5,
            showDataShadow: false,//是否显示数据阴影 默认auto
            showDetail: true,//即拖拽时候是否显示详细数值信息 默认true
            realtime: false, //是否实时更新
            filterMode: 'filter',
          },
          //下面这个属性是里面拖到
          {
            type: 'inside',
            show: true,
            // xAxisIndex: [0],
            start: 1,//默认为1
            end: 100,//默认为100
          },
        ]
      },
      wuJianChartLoading:false,
      wuJianTarget:0,
      /*供应商别不良推移*/
      optionSupplier: {
        type:'supplier_chart',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          //data: ['Evaporation', 'Precipitation', 'Temperature']
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '不良重量',
            min:0,
            max:100,
            interval:20,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(0)
              }
            }
          },
          {
            type: 'value',
            name: '不良率',
            min:0,
            max:10,
            interval:2,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(1) + '%'
              }
            }
          }
        ],
        series: [
          {
            name: '一次不良',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [

            ]
          },
          {
            name: '二次不良',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [

            ]
          },
          {
            name: '目标',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: []
          },
          {
            name: '实绩',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: []
          }
        ]
      },
      supplierChartLoading:false,
      supplierTarget:0,
      /*不良堆积图*/
      optionDrum: {
        type:'drum_chart',
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let res = ''
            let total = 0
            for (const item of params) {
              if (item.value !== "0") {
                total  += Number(item.value)
                res += `<span style="background: ${item.color}; height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:10px;"></span> ${item.seriesName} : ${item.value}<br/>`
              }
            }
            return `${params[0].name} <br/>` + `<span style="background:black; height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:13.5px;"></span>${"总计"} : ${total.toFixed(2)}<br/>` + res
          },
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          type: 'scroll',
          orient: 'horizontal'
        },
        grid: {
          left: '8%',
          right: '8%',
          bottom: '8%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '不良数量',
            max: function (value) {
              return value.max + 20;
            }
          }
        ],
        series: []
      },
      drumChartLoading:false,
      drumDate:{
        year:this.$common.getCurrentYearByMonth().toString(),
        month:this.$common.getDateLabel(new Date().getUTCMonth() + 1),
        /*day:''*/
      },
      /*班别堆积图*/
      optionClassDrum: {
        type:'classDrum_chart',
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let res = ''
            let total = 0
            for (const item of params) {
              if (item.value !== "0") {
                total  += Number(item.value)
                res += `<span style="background: ${item.color}; height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:10px;"></span> ${item.seriesName} : ${item.value}<br/>`
              }
            }
            return `${params[0].name} <br/>` + `<span style="background:black; height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:13.5px;"></span>${"总计"} : ${total.toFixed(2)}<br/>` + res
          },
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          type: 'scroll',
          orient: 'horizontal'
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '5%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '产量'
          }
        ],
        series: []
      },
      classChartLoading:false,
      classDate:{
        year:this.$common.getCurrentYearByMonth().toString(),
        month:this.$common.getDateLabel(new Date().getUTCMonth() + 1),
        /*day:''*/
      },
      /*种类别玻璃不良推移*/
      optionBlend: {
        type:'type_chart',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          //data: ['Evaporation', 'Precipitation', 'Temperature']
        },
        grid: {
          left: '10%',
          right: '10%',
          bottom: '15%',
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '不良重量',
            min:0,
            max:100,
            interval:20,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(0)
              }
            }
          },
          {
            type: 'value',
            name: '不良率',
            min:0,
            max:10,
            interval:2,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(1) + '%'
              }
            }
          }
        ],
        series: [
          {
            name: '一次不良',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [
            ]
          },
          {
            name: '目标',
            type: 'line',
            color:'#fac858',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: []
          },
          {
            name: '实绩',
            type: 'line',
            color:'#ee6666',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: []
          }
        ]
      },
      blendChartLoading:false,
      blendTarget:0,
      /*日不良率*/
      optionDayBad: {
        type:'day_chart',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
        },
        grid: {
          left: '5%',
          right: '10%',
          bottom: '15%',
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '不良重量',
            min:0,
            max:15,
            interval:5,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(0)
              }
            }
          },
          {
            type: 'value',
            name: '日不良率',
            min:0,
            max:15,
            interval:3,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(1) + '%'
              }
            }
          }
        ],
        series: [
          {
            name: '一次不良',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [

            ]
          },
          {
            name: '日不良率',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + ' %';
              }
            },
            data: [

            ]
          }
        ]
      },
      dayBadLoading:false,
    }
  },
  methods: {
    getMaxHeight() {
      let pageHeight = document.body.scrollHeight - 160;
      this.maxHeight = "height: "+pageHeight+"px;";
    },
    getDateFormat(){
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },

    renderEcharts(id,option){
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
        let _this = this
        /*let time
        //chart绑定滚动事件
        chart.on('dataZoom',function (params) {
          //滚动条事件添加防抖
          clearTimeout(time)
          time = setTimeout(()=>{
            _this.getWuJianChartData(params)
          },1000)
        })*/
        if (id === 'drumXC') {
          chart.on('legendselectchanged', function (params) {
            if (params.name === "全部") {
              for (let item in params.selected) {
                params.selected[item] = params.selected['全部']
              }
              option.legend.selected = params.selected
              // chart.clear()
              chart.setOption(option)
            }
          })
        }

        if (id === 'pieXC') {
          chart.on('legendselectchanged', function (params) {
            let array = []
            option.series[0].data.map((item)=>{
              if (params.selected[item.name]){
                array.push(item)
              }
            })
            option.legend.selected = params.selected
            option.title.text = "合计\n" + _this.$common.getPieSum(array)
            // chart.clear()
            chart.setOption(option)
          })
        }

          chart.on('click', function (params) {
            if (_this.parentData) {
              _this.dialogVisible = true
              _this.chartData.seriesName = params.seriesName
              _this.chartData.value = params.value
              _this.chartData.name = params.name
              _this.chartData.dataIndex = params.dataIndex
              _this.chartData.seriesIndex = params.seriesIndex
              _this.chartData.chartType = option.type
            }else {
              let query = {}
              query.wujian_id = _this.wuJianId
              query.supplier = _this.supplier
              query.name = params.name
              query.type = option.type
              query.seriesName = params.seriesName
              if ("pie_chart" === option.type){
                query.pieDate = _this.pieDate
              }
              if ("drum_chart" === option.type){
                query.drumDate = _this.drumDate
              }
              if ("day_chart" === option.type){
                query.dayBad = _this.dayBad
              }
              if ("type_chart" === option.type){
                query.typeBad = _this.typeBad
              }
              /*if ("classDrum_chart" === option.type){
                query.classDate = _this.classDate
              }*/
              if (params.componentSubType !== "line") {
                if (option.type === 'pie_chart' || 'drum_chart' === option.type) {
                  _this.getDataInfo(query)
                  _this.dialogItem.width = '60%'
                  _this.infoDialog = true
                }
              }
            }
            _this.dialogItem.title = params.seriesName + '-' + params.name
          })

      }
    },

    renderAllEcharts(){
      if (this.field === 'count'){
        this.yAxisName = '不良数量'
      }
      if (this.field === 'weight'){
        this.yAxisName = '不良重量'
      }
      this.getWuJianChart()
      this.getDayChart()
      this.getBlendChart()
      this.getPieChart()
      // //this.getSupplierChart()
      this.getDrumChart()
      this.getClassDrumChart()
      // this.getSuppliers()
    },

    async getDataInfo(query){
      this.infoLoading = true
      let {data:res} = await this.$axios.post('/bus/shouRuXingCai/getDataInfo',query);
      this.dataInfo = res.data
      this.infoLoading = false
    },

    async deleteChartData(){
      this.loading = true
      let {data: res} = await this.$axios.post('bus/homePage/deleteChartData',"bus_shouruxingcai_page");
      if (res.code !== 0) {
        this.$message.error('刷新失败！请重试')
      }else {
        this.$message.success('刷新成功！')
        this.renderAllEcharts()
      }
      this.loading = false
    },

    async editChartData(){
      switch (this.chartData.chartType){
        case "wujian_chart":
          this.wujianQuery.wujian_id = this.wuJianId
          this.wujianQuery.field = this.field
          this.chartData.query = this.wujianQuery
          break
        case "pie_chart":
          this.pieDate.wujian_id = this.wuJianId
          this.pieDate.field = this.field
          this.chartData.query = this.pieDate
          break
        case "supplier_chart":
          this.supplierBad.wujian_id = this.wuJianId
          this.supplierBad.field = this.field
          this.supplierBad.field1 = this.supplierBad.supplier
          this.chartData.query = this.supplierBad
          break
        case "drum_chart":
          this.drumDate.wujian_id = this.wuJianId
          this.drumDate.field = this.field
          this.chartData.query = this.drumDate
          break
        case "classDrum_chart":
          this.classDate.wujian_id = this.wuJianId
          this.classDate.field = this.field
          this.chartData.query = this.classDate
          break
        case "type_chart":
          this.typeBad.wujian_id = this.wuJianId
          this.typeBad.field = this.field
          this.typeBad.field1 = this.typeBad.type
          this.chartData.query = this.typeBad
          break
        case "day_chart":
          this.dayBad.wujian_id = this.wuJianId
          this.dayBad.field = this.field
          this.chartData.query = this.dayBad
          break
      }
      this.chartData.model = "bus_shouruxingcai_page"
      this.chartData.dataKey = this.$common.getChartDataKey(this.chartData)
      let {data: res} = await this.$axios.post('bus/homePage/editChartData',this.chartData);
      if (res.code !== 0) {
        this.$message.error('修改失败！请重试')
      }else {
        this.$message.success('修改成功！')
        this.dialogVisible = false
      }
      switch (this.chartData.chartType){
        case "wujian_chart":
          await this.getWuJianChart()
          break
        case "pie_chart":
          await this.getPieChart()
          break
        case "supplier_chart":
          await this.getSupplierChart()
          break
        case "drum_chart":
          await this.getDrumChart()
          break
        case "classDrum_chart":
          await this.getClassDrumChart()
          break
        case "type_chart":
          await this.getBlendChart()
          break
        case "day_chart":
          await this.getDayChart()
          break
      }

    },

    async getSuppliers() {
      this.supplierBad.supplier = ''
      let search = {
        wujian_id:this.wuJianId,
        method_param_prefix__0:'bus_xingcai_zhijian_info.supplier_name'
      }
      let {data: res} = await this.$axios.post('bus/datasource/getBoLiSupplier',search);
      if (res.code !== 0) {
        this.$message.error('获取供应商失败')
        return;
      }
      this.suppliers = res.data;
      for (let i = this.suppliers.length - 1; i >= 0 ; i--) {
        if (this.suppliers[i].value === "苏州凯朗德金属科技有限公司" || this.suppliers[i].value === "苏州腾研精密机械有限公司"
            || this.suppliers[i].value === "苏州市瑞林压铸模具厂" || this.suppliers[i].value === "佛山市南燊金属型材制品有限公司"){
          this.suppliers.splice(i,1)
        }
      }
    },

    async getWuJianInFo() {
      let {data: res} = await this.$axios.post('bus/datasource/getWuJianInFo');
      if (res.code !== 0) {
        this.$message.error('获取【物件信息】失败')
        return;
      }
      this.wuJianNames = res.data;
    },

    async getDayChart() {
      if (!this.dayBad.dateDay){
        this.dayBad.dateDay = this.getDateFormat()
      }
      this.dayBadLoading = true
      this.dayBad.wujian_id = this.wuJianId
      this.dayBad.supplier = this.supplier
      this.dayBad.field = this.field
      let {data: res} = await this.$axios.post('bus/xingcaiCharts/dayChart',this.dayBad);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      if (res.data.days) {
        this.optionDayBad.xAxis[0].data = res.data.days
        this.optionDayBad.series[0].data = res.data.ng1s
        this.optionDayBad.series[1].data = res.data.percentages
        this.optionDayBad.yAxis[0].max = Math.ceil(Math.max(...res.data.ng1s)/100)*100
        this.optionDayBad.yAxis[0].interval = Math.round(this.optionDayBad.yAxis[0].max/5*100)/100
        /*this.optionDayBad.yAxis[1].max = Math.max(...res.data.badPercent) + 5
        this.optionDayBad.yAxis[1].interval = Math.round(this.optionDayBad.yAxis[1].max/5*100)/100*/
      }
      this.optionDayBad.yAxis[0].name = this.yAxisName
      this.renderEcharts('dayBadXC',this.optionDayBad)

      this.dayBadLoading = false
    },

    async getBlendChart() {
      this.blendChartLoading = true
      if (!this.typeBad.year){
        this.typeBad.year = this.$common.getCurrentYearByMonth().toString()
      }
      this.typeBad.wujian_id = this.wuJianId
      this.typeBad.field = this.field
      this.typeBad.supplier = this.supplier
      let {data: res} = await this.$axios.post('bus/xingcaiCharts/blendChart',this.typeBad);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      if (res.data.days) {
        this.optionBlend.xAxis[0].data = res.data.days
        this.optionBlend.series[0].data = res.data.ng1s
        this.optionBlend.series[1].data = res.data.targets
        this.optionBlend.series[2].data = res.data.percentages
        let a = this.$common.getDivisor(Math.max(...res.data.ng1s))
        this.optionBlend.yAxis[0].max = Math.ceil(Math.max(...res.data.ng1s)/a)*a
        this.optionBlend.yAxis[0].interval = Math.round(this.optionBlend.yAxis[0].max/5*100)/100
        /*this.optionBlend.yAxis[1].max = Math.max(Math.max(...res.data.badPercent),this.blendTarget) + 5
        this.optionBlend.yAxis[1].interval = Math.round(this.optionBlend.yAxis[1].max/5*100)/100*/
      }
      this.optionBlend.yAxis[0].name = this.yAxisName
      this.renderEcharts('blendXC',this.optionBlend)

      this.blendChartLoading = false
    },

    async getSupplierChart() {
      this.supplierChartLoading = true
      if (!this.supplierBad.year){
        this.supplierBad.year = this.$common.getCurrentYearByMonth().toString()
      }
      this.supplierBad.wujian_id = this.wuJianId
      this.supplierBad.supplier = this.supplier
      this.supplierBad.field = this.field
      let {data: res} = await this.$axios.post('bus/shouRuXingCai/supplierChart',this.supplierBad);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      this.optionSupplier.xAxis[0].data = res.data.XMonth
      this.optionSupplier.series[0].data = res.data.badNum
      this.optionSupplier.series[1].data = res.data.badNumTwo
      if (res.data[this.supplierBad.year-1] && res.data[this.supplierBad.year]) {
        for (let i = 0; i < 3; i++) {
          this.optionSupplier.series[2].data.push(res.data[this.supplierBad.year - 1])
        }
        for (let i = 3; i < res.data.XMonth.length; i++) {
          this.optionSupplier.series[2].data.push(res.data[this.supplierBad.year])
        }
      }
      this.optionSupplier.series[3].data = res.data.badPercent
      let a = this.$common.getDivisor(Math.max(...res.data.badNum))
      this.optionSupplier.yAxis[0].max = Math.ceil(Math.max(...res.data.badNum)/a)*a
      this.optionSupplier.yAxis[0].interval = Math.round(this.optionSupplier.yAxis[0].max/5*100)/100
      /*this.optionSupplier.yAxis[1].max = Math.max(Math.max(...res.data.badPercent),this.supplierTarget) + 5
      this.optionSupplier.yAxis[1].interval = Math.round(this.optionSupplier.yAxis[1].max/5*100)/100*/
      this.optionSupplier.yAxis[0].name = this.yAxisName
      this.renderEcharts('supplierXC',this.optionSupplier)

      this.supplierChartLoading = false
    },

    async getWuJianChart() {
      this.wuJianChartLoading = true
      this.getSuppliers()
      this.wujianQuery.wujian_id = this.wuJianId
      this.wujianQuery.field = this.field
      this.wujianQuery.field1 = this.supplier
      let {data: res} = await this.$axios.post('bus/xingcaiCharts/wuJianChart1',this.wujianQuery);
      if (res.code !== 0) {
        this.$message.error(res.message)
        this.optionWuJian.series[0].data = null
        this.optionWuJian.series[1].data = null
        this.optionWuJian.series[2].data = []
        this.optionWuJian.series[3].data = []
        this.wuJianChartLoading = false
      }else {
        if (res.data) {
          this.optionWuJian.xAxis[0].data = res.data.months
          this.optionWuJian.series[0].data = res.data.ng1s
          this.optionWuJian.series[1].data = res.data.ng2s
          if (res.data.targets) {
            this.optionWuJian.series[2].data = res.data.targets
          }
          this.optionWuJian.series[3].data = res.data.percentages
          let a = this.$common.getDivisor(Math.max(...res.data.ng1s))
          this.optionWuJian.yAxis[0].max = Math.ceil(Math.max(...res.data.ng1s)/a)*a
          this.optionWuJian.yAxis[0].interval = Math.round(this.optionWuJian.yAxis[0].max/5*100)/100
          /*this.optionWuJian.yAxis[1].max = Math.max(Math.max(...res.data.badPercent),this.wuJianTarget) + 5
          this.optionWuJian.yAxis[1].interval = Math.round(this.optionWuJian.yAxis[1].max/5*100)/100*/
          this.optionWuJian.dataZoom[0].start = Math.max((this.optionWuJian.xAxis[0].data.length - 4),0) * 100 / this.optionWuJian.xAxis[0].data.length
          this.optionWuJian.dataZoom[0].end = 100
        }
      }
      this.optionWuJian.yAxis[0].name = this.yAxisName
      this.renderEcharts('wuJianXC',this.optionWuJian)

      this.wuJianChartLoading = false
    },

    /*async getWuJianChartData(params) {
      let range
      if (params.batch){
        range = params.batch[0]
      }else {
        range = params
      }
      this.wuJianChartLoading = true
      let query = {
        wuJianId:this.wuJianId,
        field:this.field,
        start:Math.floor(this.optionWuJian.xAxis[0].data.length * range.start/100),
        end:Math.ceil(this.optionWuJian.xAxis[0].data.length * range.end/100),
      }
      let {data: res} = await this.$axios.post('bus/shouRuXingCai/wuJianChart',JSON.stringify(query));
      if (res.code !== 0) {
        this.$message.error(res.message)
        this.wuJianChartLoading = false
      }else {
        if (res.data.XMonth) {
          this.optionWuJian.xAxis[0].data = res.data.XMonth
          this.optionWuJian.series[0].data = res.data.badNum
          this.optionWuJian.series[1].data = res.data.badNumTwo
          for (let i = 0; i < this.optionWuJian.xAxis[0].data.length; i++) {
            this.optionWuJian.series[2].data.push(this.wuJianTarget)
          }
          this.optionWuJian.series[3].data = res.data.badPercent
          let a = this.$common.getDivisor(Math.max(...res.data.badNum))
          this.optionWuJian.yAxis[0].max = Math.ceil(Math.max(...res.data.badNum)/a)*a
          this.optionWuJian.yAxis[0].interval = Math.round(this.optionWuJian.yAxis[0].max/5*100)/100
          /!*this.optionWuJian.yAxis[1].max = Math.max(Math.max(...res.data.badPercent),this.wuJianTarget) + 5
          this.optionWuJian.yAxis[1].interval = Math.round(this.optionWuJian.yAxis[1].max/5*100)/100*!/
          this.optionWuJian.dataZoom[0].start = range.start
          this.optionWuJian.dataZoom[0].end = range.end
        }
        this.optionWuJian.yAxis[0].name = this.yAxisName
        this.renderEcharts('wuJianXC',this.optionWuJian)
      }
      this.wuJianChartLoading = false
    },*/

    async getPieChart() {
      if (!this.pieDate.year){
        this.pieDate.year =  this.$common.getCurrentYearByMonth().toString()
      }
      this.pieChartLoading = true
      this.pieDate.wujian_id = this.wuJianId
      this.pieDate.field = this.field
      this.pieDate.supplier = this.supplier
      let {data: res} = await this.$axios.post('bus/xingcaiCharts/pieChart',this.pieDate);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      this.optionPie.legend.data = res.data
      this.optionPie.series[0].data = res.data
      this.optionPie.title.text = "合计\n" + this.$common.getPieSum(this.optionPie.series[0].data)
      this.renderEcharts('pieXC',this.optionPie)

      this.pieChartLoading = false
    },

    async getDrumChart() {
      if (!this.drumDate.year){
        this.drumDate.year =  this.$common.getCurrentYearByMonth().toString()
      }
      this.drumChartLoading = true
      this.drumDate.wujian_id = this.wuJianId
      this.drumDate.field = this.field
      this.drumDate.supplier = this.supplier
      let {data: res} = await this.$axios.post('bus/xingcaiCharts/drumChart',this.drumDate);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      if (res.data) {
        this.optionDrum.xAxis[0].data = res.data.dayList
        this.optionDrum.series = res.data.series
        this.optionDrum.yAxis[0].name = this.yAxisName
        this.renderEcharts('drumXC', this.optionDrum)
      }

      this.drumChartLoading = false
    },

    async getClassDrumChart() {
      if (!this.classDate.year){
        this.classDate.year =  this.$common.getCurrentYearByMonth().toString()
      }
      this.classChartLoading = true
      this.classDate.wujian_id = this.wuJianId
      this.classDate.field = this.field
      this.classDate.supplier = this.supplier
      let {data: res} = await this.$axios.post('bus/xingcaiCharts/classDrumChart',this.classDate);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      if (res.data) {
        this.optionClassDrum.xAxis[0].data = res.data.dayList
        this.optionClassDrum.series = res.data.series
        this.optionClassDrum.yAxis[0].name = this.yAxisName.substring(2)
        this.renderEcharts('classXC', this.optionClassDrum)
      }

      this.classChartLoading = false
    },

    async getTargetDict() {
      let {data: res} = await this.$axios.post('bus/datasource/getDictList','home_page');
      if (res.code !== 0) {
        this.$message.error('获取目标值失败')
        return;
      }
      res.data.forEach((item)=>{
        if (item.id === "shouru_xingcai_blend"){
          this.blendTarget = item.name
        }
        if (item.id === "shouru_xingcai_wujian"){
          this.wuJianTarget = item.name
        }
        if (item.id === "shouru_xingcai_supplier"){
          this.supplierTarget = item.name
        }
      })
    },
  },

  created() {
    this.getMaxHeight()
    this.getWuJianInFo()
    this.getSuppliers()
    this.getTargetDict()
  },

  beforeMount() {

  },

  mounted() {
    this.renderAllEcharts()
  }
}
</script>

<style scoped>
.topContainer{
  display: flex;
  flex-direction: row;
}

.pageContainer{
  display: flex;
  flex-direction: row;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.space-between{
  display: flex;
  flex-direction: row;
  align-items: center;;
}

.asideContainer{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

.wujian_size{
  width: 940px;
  height: 200px
}

.chartSize{
  width: 470px;
  height: 190px
}

.title{
  border-left: 3px solid steelblue;
  height: 25px;
  width: 80%;
  font-size: 16px;
  margin-left: 40px;
}

.summary{
  height: 190px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.messageCard{
  width: 100px;
  height: 65px;
  background-color:whitesmoke;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

margin-right{
  margin-right: 5px;
}

.message{
  color: whitesmoke;
  border-radius: 5px;
}
</style>